import { render } from "./TipShareTable.vue?vue&type=template&id=065cfb8d"
import script from "./TipShareTable.vue?vue&type=script&lang=js"
export * from "./TipShareTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__